import React, { Component } from 'react';
import { View } from 'react-native';

import TabBar from '../../components/tabBar';
import styles from './styles';

class RootView extends Component {
    render() {
        const { navigation, children } = this.props;

        return (
            <View id="root-view" className="root-view" style={styles.container}>
                <TabBar style={styles.appHeader} navigation={navigation} />

                <View style={styles.content}>{children}</View>
            </View>
        );
    }
}

export default RootView;
